import { Alert, AlertProps } from '@mui/material';
import styled from 'styled-components';

export const StyledErrorAlert = styled(Alert)<AlertProps>`
  border-radius: 8px;
  background-color: ${props => props.theme.colors.orange['10']};
  ${props => props.theme.typography.webCaption};
  display: flex;
  align-items: center;

  strong {
    font-weight: 700;
  }

  .MuiAlert-icon {
    margin-right: 8px;

    .MuiSvgIcon-root {
      width: 16px;
      height: 16px;
      color: ${props => props.theme.colors.red['100']};
    }
  }

  .MuiAlert-message {
    padding: 0;
  }

  .MuiAlert-action {
    padding: 0;

    .MuiSvgIcon-root {
      color: ${props => props.theme.colors.darkGrey['40']};
    }
  }
`;

export const StyledSuccessAlert = styled(Alert)<AlertProps>`
  border-radius: 8px;
  background-color: ${props => props.theme.colors.success['10']};
  ${props => props.theme.typography.webCaption};
  display: flex;
  align-items: center;
`;
